import type { ConfigurationActivationConfig } from '@/graphql/configuration/api';

const normalizeModuleName = (moduleName: string | null | undefined) =>
  moduleName ? moduleName.toLowerCase().replace(/_/g, ' ') : '';

export const isServiceActive = (
  moduleActivations: ConfigurationActivationConfig[] | null,
  serviceIdentifier: string | undefined | null,
  normalize = false,
) => {
  if (!moduleActivations) {
    return false;
  }

  const normalizedIdentifier = normalize
    ? normalizeModuleName(serviceIdentifier)
    : serviceIdentifier;

  const matchingModule = moduleActivations.find((module) =>
    normalize
      ? normalizeModuleName(module.module) === normalizedIdentifier
      : module.module === normalizedIdentifier,
  );

  return matchingModule?.active === true;
};
